import { useState } from "react";
import ProductoLista from "../lista/ProductoLista.js";
import iconCanasta from "../../../../../assets/img/icons/ventas/canasta.svg";

import "./canasta.css";

export default function CanastaProductos({ 
  productos,
  onEliminar, 
  onActualizarCantidad, 
  onLimpiarCanasta,
 }) {
  const [abierta, setAbierta] = useState(false);


  // Si hay mesa seleccionada, tomamos sus productos
  const productosEnCanasta = productos;

  return (
    <>
      {/* BOTÓN EXTERNO (icono canasta) */}
      <div className="canasta-barra">
        <button
          className="canasta-boton"
          onClick={() => setAbierta(true)}
          aria-label="Abrir canasta"
        >
          <img src={iconCanasta} alt="Canasta" />
          <span className="canasta-texto">Ver canasta</span>
          <span className="canasta-contador">({productosEnCanasta.length})</span>
        </button>
      </div>

      {/* SIDEBAR */}
      {abierta && (
        <div className="canasta-panel abierta">
          {/* HEADER */}
          <div className="canasta-header">
            <span className="canasta-titulo">
              Canasta ({productosEnCanasta.length})
            </span>

            <button
              className="canasta-cerrar"
              onClick={() => setAbierta(false)}
              aria-label="Cerrar canasta"
            >
              ✕
            </button>
          </div>

          {/* CONTENIDO */}
          <div className="canasta-contenido">
            <ProductoLista
              productos={productosEnCanasta}
              onEliminar={onEliminar}
              onActualizarCantidad={onActualizarCantidad}
              onOrdenCreada={() => {
                setAbierta(false);
                 onLimpiarCanasta?.();
              }}
            />
          </div>
        </div>
      )}
    </>
  );
}
